module.exports = __webpack_public_path__ + "img/wiretransfer.e0db9a68.svg";